import { t } from 'ember-intl';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import TuitionAssistanceCardsGeneric from 'tio-common/components/tuition-assistance/cards/generic';
import Svg from 'tio-employee/components/svg';
import AddDependent from '../forms/add-dependents';
import type IntlService from 'ember-intl/services/intl';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';

export interface S {
  Args: {
    employee: EmployeeModel;
  };
}

export default class TuitionAssistanceDashboardManageDependents extends Component<S> {
  @service declare intl: IntlService;
  @tracked show = false;

  <template>
    <div>
      <TuitionAssistanceCardsGeneric class="items-center">
        <:headerTitle>
          <p data-test-manage-dependents-header>{{t
              "common.tuition_assistance.dashboard.manage_dependents_header"
            }}</p>
        </:headerTitle>
        <:body>
          <div class="tio-col-flush align-center">
            <div class="flex">
              <p data-test-manage-dependents-text>{{t
                  "common.tuition_assistance.dashboard.manage_dependents_text"
                }}.</p>
            </div>
            <div class="tio-flex-center py-4">
              <Svg
                @name="family"
                role="img"
                aria-label={{t "svg.family"}}
                width="150px"
                height="150px"
              />
            </div>
          </div>
        </:body>
        <:footer>
          <div class="tio-flex-center">
            <AddDependent @employee={{@employee}} />
          </div>
        </:footer>
      </TuitionAssistanceCardsGeneric>
    </div>
  </template>
}
